(function(){
  function dates(){
    if (!window.Intl || !Intl.DateTimeFormat) return;
    // Tijd van Amsterdam, ongeacht waar de bezoeker zit.
    var delen = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit'
    }).formatToParts(new Date()).forEach(function (p) { delen[p.type] = p.value; });
    var uur = parseInt(delen.hour, 10) % 24, min = parseInt(delen.minute, 10);
    var dag = new Date(Date.UTC(+delen.year, +delen.month - 1, +delen.day));

    /* Verzenddagen: 0 = zondag, 1 t/m 5 = maandag t/m vrijdag, 6 = zaterdag.
       27 september 2026: er wordt ook op zondag verzonden en niet op zaterdag. Een
       bestelling van zaterdag gaat dus zondag mee. Verandert dit (bijvoorbeeld
       zaterdag erbij), pas dan alleen deze lijst aan. Sluitingstijd voor dezelfde
       dag verzenden: 23:30. */
    var VERZENDDAGEN = [0, 1, 2, 3, 4, 5];
    /* Bezorgdagen: maandag t/m zaterdag (data-zat="1", nu voor alle landen), nooit
       op zondag. Bezorgt een land niet op zaterdag, zet dan data-zat op 0 via
       ke_zaterdag in snippets/kopero-levering. */
    function bezorgdag(d, metZaterdag) { var w = d.getUTCDay(); return w !== 0 && (w !== 6 || metZaterdag); }

    function plus(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
    function verzenddag(d) { return VERZENDDAGEN.indexOf(d.getUTCDay()) !== -1; }
    function volgendeVerzenddag(d) { var x = plus(d, 1); while (!verzenddag(x)) x = plus(x, 1); return x; }
    function telBezorgdagen(d, n, metZaterdag) {
      var x = d;
      for (var i = 0; i < n; i++) { x = plus(x, 1); while (!bezorgdag(x, metZaterdag)) x = plus(x, 1); }
      return x;
    }

    var voorSluiting = verzenddag(dag) && (uur * 60 + min) < (23 * 60 + 30);
    var verzend = voorSluiting ? dag : volgendeVerzenddag(dag);
    var taal = document.documentElement.lang || 'nl';

    function fmt(d) {
      try { return new Intl.DateTimeFormat(taal, { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(d); }
      catch (e) { return ''; }
    }

    document.querySelectorAll('[data-ke-levering]').forEach(function (regel) {
      if (regel.dataset.keBeschikbaar === 'false') return;
      var lo = parseInt(regel.getAttribute('data-min'), 10), hi = parseInt(regel.getAttribute('data-max'), 10);
      var zat = regel.getAttribute('data-zat') === '1';
      var laatste = telBezorgdagen(verzend, hi, zat);
      var datum = fmt(laatste);
      if (!datum) return;
      var sjabloon = regel.getAttribute(lo === hi ? 'data-tekst-een' : 'data-tekst-tot') || '';
      var doel = regel.querySelector('[data-ke-datum]');
      if (doel && sjabloon) doel.textContent = sjabloon.replace('{d}', datum);
    });

  }
  function sync(id){
    document.querySelectorAll('[data-ke-voorraad]').forEach(function(root){
      var variants=JSON.parse(root.dataset.keVoorraad), v=variants[String(id)];
      if(!v)return;
      root.dataset.keBeschikbaar=String(v.available);
      root.querySelector('[data-ke-stock="ja"]').hidden=!v.available;
      root.querySelector('[data-ke-stock="nee"]').hidden=v.available;
      var form=root.closest('.ke-bst')?.querySelector('form');
      if(form){
        form.querySelector('[name="id"]').value=String(id);
        var button=form.querySelector('.ke-bst-knop');
        button.disabled=!v.available;button.textContent=v.available?button.dataset.keAdd:button.dataset.keSoldout;
      }
    });
    dates();
  }
  function mainId(){return document.querySelector('product-info .product-form [name="id"], .product__info-container form[action*="/cart/add"] [name="id"]')?.value;}
  function start(){
    dates();
    if(window.subscribe&&window.PUB_SUB_EVENTS)subscribe(PUB_SUB_EVENTS.variantChange,function(e){sync(e?.data?.variant?.id||mainId());});
    document.addEventListener('change',function(e){
      if(e.target.matches('.ke-bst-select')){
        var root=e.target.closest('.ke-bst').querySelector('[data-ke-voorraad]');
        var v=JSON.parse(root.dataset.keVoorraad)[e.target.value];
        var picker=document.querySelector('product-info variant-selects');
        if(picker&&v){
          var last;
          picker.querySelectorAll('fieldset, .product-form__input--dropdown').forEach(function(group,i){
            var radio=Array.from(group.querySelectorAll('input[type="radio"]')).find(function(r){return r.value===v.options[i];});
            if(radio){radio.checked=true;last=radio;}
            var select=group.querySelector('select');if(select){select.value=v.options[i];last=select;}
          });
          if(last)last.dispatchEvent(new Event('change',{bubbles:true}));
        }
        sync(e.target.value);
      }else if(e.target.closest('variant-selects'))setTimeout(function(){sync(mainId());},300);
    });
    document.addEventListener('shopify:section:load',function(){sync(mainId());});
    window.addEventListener('pageshow',function(){sync(mainId());});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
